var _path, _path2, _g, _circle, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_283",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_283)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 39,
    r: 3,
    fill: "#309BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 46L42 59H57L49.5 46Z",
    fill: "#8EC9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 39L27 59H50L38.5 39Z",
    fill: "#309BFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#309BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.907 72.3182H17.3331V79.358C17.3298 80.0175 17.1723 80.5942 16.8608 81.0881C16.5492 81.5786 16.1184 81.9598 15.5682 82.2315C15.0213 82.5033 14.3883 82.6392 13.669 82.6392C13.0327 82.6392 12.4543 82.5282 11.9339 82.3061C11.4169 82.084 11.0043 81.7393 10.696 81.272C10.3911 80.8047 10.2403 80.2064 10.2436 79.4773H12.6946C12.7045 79.7391 12.7543 79.9628 12.8438 80.1484C12.9366 80.3307 13.0642 80.4683 13.2266 80.5611C13.389 80.6539 13.5829 80.7003 13.8082 80.7003C14.0436 80.7003 14.2424 80.6506 14.4048 80.5511C14.5672 80.4484 14.6899 80.2976 14.7727 80.0987C14.8589 79.8999 14.9036 79.6529 14.907 79.358V72.3182ZM18.878 82.5V72.3182H23.084C23.8463 72.3182 24.5042 72.4673 25.0577 72.7656C25.6145 73.0606 26.0437 73.4732 26.3453 74.0036C26.647 74.5305 26.7978 75.1437 26.7978 75.843C26.7978 76.5457 26.6436 77.1605 26.3354 77.6875C26.0305 78.2112 25.5946 78.6172 25.0279 78.9055C24.4611 79.1939 23.7883 79.3381 23.0094 79.3381H20.4142V77.3991H22.552C22.9232 77.3991 23.2331 77.3345 23.4817 77.2053C23.7336 77.076 23.9242 76.8954 24.0534 76.6634C24.1827 76.428 24.2473 76.1546 24.2473 75.843C24.2473 75.5282 24.1827 75.2564 24.0534 75.0277C23.9242 74.7957 23.7336 74.6167 23.4817 74.4908C23.2298 74.3648 22.9199 74.3018 22.552 74.3018H21.339V82.5H18.878ZM34.6926 75.6442C34.6363 75.4354 34.5534 75.2514 34.4441 75.0923C34.3347 74.9299 34.2005 74.7924 34.0414 74.6797C33.8823 74.567 33.7 74.4825 33.4945 74.4261C33.289 74.3665 33.0636 74.3366 32.8184 74.3366C32.3245 74.3366 31.897 74.456 31.5357 74.6946C31.1777 74.9332 30.901 75.2812 30.7054 75.7386C30.5099 76.1927 30.4121 76.7446 30.4121 77.3942C30.4121 78.0471 30.5066 78.6039 30.6955 79.0646C30.8844 79.5253 31.1578 79.8767 31.5158 80.1186C31.8738 80.3606 32.3079 80.4815 32.8184 80.4815C33.2691 80.4815 33.6503 80.4086 33.9618 80.2628C34.2767 80.1136 34.5153 79.9032 34.6777 79.6314C34.8401 79.3596 34.9213 79.0398 34.9213 78.6719L35.3787 78.7266H32.9029V76.9318H37.2928V78.2791C37.2928 79.1906 37.0989 79.9711 36.7111 80.6207C36.3266 81.2704 35.7963 81.7692 35.1202 82.1172C34.4474 82.4652 33.6735 82.6392 32.7985 82.6392C31.8274 82.6392 30.9739 82.4287 30.2381 82.0078C29.5023 81.5869 28.9289 80.987 28.5179 80.2081C28.1069 79.4259 27.9015 78.4979 27.9015 77.424C27.9015 76.5888 28.0257 75.848 28.2743 75.2017C28.5229 74.5521 28.8693 74.0019 29.3134 73.5511C29.7608 73.1004 30.2779 72.759 30.8645 72.527C31.4545 72.295 32.0892 72.179 32.7686 72.179C33.3586 72.179 33.9071 72.2635 34.4142 72.4325C34.9247 72.6016 35.3754 72.8402 35.7665 73.1484C36.1609 73.4567 36.4808 73.8229 36.726 74.2472C36.9713 74.6714 37.1238 75.1371 37.1834 75.6442H34.6926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoJpg);
export default __webpack_public_path__ + "static/media/ico_jpg.c68b045b5e13ca686687d96fda210981.svg";
export { ForwardRef as ReactComponent };